import { render } from "./form_10.vue?vue&type=template&id=d263ceb0"
import script from "./form_10.vue?vue&type=script&lang=js"
export * from "./form_10.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/forms/form_10.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d263ceb0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d263ceb0', __exports__)) {
    console.log('reload')
    api.reload('d263ceb0', __exports__)
  }
  
  module.hot.accept("./form_10.vue?vue&type=template&id=d263ceb0", () => {
    console.log('re-render')
    api.rerender('d263ceb0', render)
  })

}


export default __exports__